
const filtroBusquedaPGState = {
  loading: null,
  tiposAtencion: [],
  problemasSalud: [],
  intSanitarias: [],
  canastas: [],
  modalNuevaPrestacion: false,
  solicitudEnCurso: false,
  filtros: {
    tipoAtencion: "T",
    problemaSalud: 0,
    intervencionSanitaria: "A",
    canasta: null,
    codIsapre: null,
    codPrestador: "",
  },
  paqueteGES: [],
  solicitudes: [],
  modalCargarBorrador: false,
  prestacionesSolicitud: [],
  idSolicitud: null,
  pageSize: 0,
  totalPage: 0,
};

export default filtroBusquedaPGState;
